import React, { useState } from "react";
import { green } from "@mui/material/colors";
import { postDeliveryMarkup } from "../../../../api/SettingsApi";

function useDeliveryMarkupSelector(deliveryMarkup: string) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
  };

  const handleButtonClick = async () => {
    setLoading(true);
    setTimeout(async () => {
      const bool = deliveryMarkup === "Yes" ? true : false;
      const res = await postDeliveryMarkup(bool);

      if (res.data === "Settings Updated") {
        setLoading(false);
        return setSuccess(true);
      }

      return setLoading(false);
    }, 800);
  };

  return {
    handleButtonClick,
    buttonSx,
    loading,
    success,
  };
}

export default useDeliveryMarkupSelector;
